import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from '@material-ui/core';
import Header from 'Components/common/Header';
import InventoryCard from 'Components/inventoryQuery/InventoryCard';

import {
    getInventoryQueryList,
    getMoregetInventoryQueryList,
} from 'Actions/inventoryQuery';
import LoadingIcon from 'Components/icons/LoadingIcon';
import {openNotification} from 'Actions/notification';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import SearchInput from 'Components/common/SearchInput';
import util from 'Utils/commonUtil';
import {T} from 'Actions/translate';

class InventoryQueryDetails extends Component {
    editQuantitys = {};
    pager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };
    state = {
        listLoaded: false,
        searchValue: '',
        getDataStatus: null,
    };

    componentDidMount() {
        const {localData} = this.props;
        let queryKey;
        if (this.props.history.location && this.props.history.location.state) {
            queryKey = this.props.history.location.state;

            this.setState({
                searchValue: queryKey,
                getDataStatus: 'success',
            });
        } else {
            this.setState({
                getDataStatus: null,
            });
        }
        this.setState({
            listLoaded: true,
        });
        this.props
            .getInventoryQueryList({
                pageNum: 1,
                pageSize: 10,
                scId: localData.defaultScId,
                orderByColumn: 'id',
                isAsc: 'asc',
                // queryKey: queryKey.trim(),
                queryKey: '',
            })
            .then((res) => {
                console.log('componentDidMount getInventoryQueryList res', res);
                if (res && res.status === 'success') {
                    this.setState({
                        listLoaded: false,
                    });
                }
            });
    }

    changeNum = (item, quantity) => {
        if (item.autoStockQuantity !== quantity) {
            this.editQuantitys[item.productId] = quantity;
        }
    };

    hideLoading = () => {
        this.setState({
            listLoaded: false,
        });
    };

    getMore = () => {
        const {localData, inventoryQueryList} = this.props;

        this.props
            .getMoregetInventoryQueryList({
                pageSize: 10,
                pageNum:
                    inventoryQueryList && inventoryQueryList.pageNum
                        ? inventoryQueryList.pageNum + 1
                        : 1,
                queryKey: this.state.searchValue.trim(),
                scId: localData.defaultScId,
                orderByColumn: 'id',
                isAsc: 'asc',
            })
            .then((res) => {
                if (!this.props.inventoryQueryAbyss) {
                    this.pager.page = res.pageNum;
                    this.pager.total = res.total;
                    this.pager.pageTotal = res.pageTotal;
                } else {
                    this.pager.page = 0;
                    this.pager.total = res.total;
                    this.pager.pageTotal = res.pageTotal;
                }
            });
    };
    goBack = () => {
        this.props.history.push('/inventoryQuery');
    };

    //搜索
    handleSearch = () => {
        const {localData} = this.props;
        const {searchValue} = this.state;

        this.setState({
            listLoaded: true,
        });
        this.props
            .getInventoryQueryList(
                {
                    pageNum: 1,
                    pageSize: 10,
                    scId: localData.defaultScId,
                    queryKey: this.state.searchValue.trim(),
                    orderByColumn: 'id',
                    isAsc: 'asc',
                },
                this.hideLoading,
            )
            .then((res) => {
                if (res && res.status && res.data.length > 0) {
                    this.pager.page = 0;
                    this.pager.total = res.total;
                    this.pager.pageTotal = res.pageTotal;
                }
                if (res['status']) {
                    this.setState({
                        getDataStatus: 'success',
                    });
                }
                this.setState({
                    listLoaded: false,
                });
            });
    };

    onChange = (title, value) => {
        this.setState({[title]: value});
    };

    render() {
        const {
            localData,
            f1CartCount,
            history,
            inventoryQueryList,
            inventoryQueryLoadingMore,
            inventoryQueryListLoaded,
        } = this.props;
        const {listLoaded, searchValue, getDataStatus} = this.state;
        console.log('render inventoryQueryList', inventoryQueryList);

        return (
            <div className="replenishment-sc-details">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    hasF1ShoppingCart={false}
                    hasUserCenter={true}
                    increment={0}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-title" item xs={12}>
                            <span>{T('user_center_inventory_details')}</span>
                        </Grid>
                    </Grid>

                    <Grid
                        className="supply-center-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid
                            className="supply-center-title text-ellipsis"
                            item
                            xs={12}>
                            <span>
                                {T('fone_order_current_is')}{' '}
                                {localData.defaultScName}
                            </span>
                        </Grid>
                    </Grid>

                    <Grid
                        className="page-search-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid item xs={11}>
                            <SearchInput
                                title="searchValue"
                                value={searchValue}
                                search={this.handleSearch}
                                onChange={this.onChange}
                                placeholder={T(
                                    'enter_sku_and_product_name',
                                )}></SearchInput>
                        </Grid>
                    </Grid>
                </Header>

                {listLoaded ? (
                    <LoadingIcon className="circle-animation" />
                ) : (
                    <Grid
                        className="replenishment-sc-list-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <ScrollWrapper
                            showLoadingMore={inventoryQueryLoadingMore}
                            showAbyss={
                                inventoryQueryList.pageNum >=
                                inventoryQueryList.pageTotal
                            }
                            getMoreData={this.getMore}
                            listLoaded={inventoryQueryListLoaded}>
                            {inventoryQueryList.data
                                ? inventoryQueryList.data.map((item, i) => (
                                      <Grid
                                          className="replenishment-sc-list"
                                          key={item.productId}
                                          item
                                          xs={11}>
                                          <InventoryCard
                                              inventroyDetails={item}
                                              handleSearch={this.handleSearch}
                                              changeNum={this.changeNum}
                                              searchValue={searchValue}
                                              history={history}
                                          />
                                      </Grid>
                                  ))
                                : null}
                        </ScrollWrapper>
                    </Grid>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, inventoryQuery} = state;
    return {
        localData: localData,
        inventoryQueryList: inventoryQuery.inventoryQueryList,
        inventoryQueryListLoaded: inventoryQuery.inventoryQueryListLoaded,
        inventoryQueryLoadingMore: inventoryQuery.inventoryQueryLoadingMore,
        inventoryQueryAbyss: inventoryQuery.inventoryQueryAbyss,
    };
};

const mapDispatchToProps = {
    openNotification,

    getInventoryQueryList,
    getMoregetInventoryQueryList,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(InventoryQueryDetails);
